import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./WorkingTime.css";

import history from "../../../../history";

import ReportList from "./ReportList";
import ExternalList from "./ExternalList";
import Report from "./Report/Report";

class WorkingTime extends React.Component {
    render() {
        let isSupervisor = this.props.currentUser.subUnits.find(u => u.ranking === 1);
        let isCoordinator = this.props.currentUser.isCoordinator;

        return (
            <React.Fragment>
                <div className="working-time-component ui container">
                    {isSupervisor || isCoordinator ? (
                        <React.Fragment>
                            <div className={`ui ${isSupervisor && isCoordinator ? "three" : "two"} item menu`}>
                                {isSupervisor ? (
                                    <Link to="/working-time/employees?month=current" className={`${this.props.type === "list" || this.props.type === "report" ? "active " : ""}item`}>
                                        <div className="content">Raporty pracowników</div>
                                    </Link>
                                ) : null}
                                {isCoordinator ? (
                                    <Link to="/working-time/external?month=current" className={`${this.props.type === "externalList" || this.props.type === "externalReport" ? "active " : ""}item`}>
                                        <div className="content">Raporty pracowników zewnętrznych</div>
                                    </Link>
                                ) : null}
                                <Link to="/working-time/my?month=current" className={`${this.props.type === "my" ? "active " : ""}item`}>
                                    <div className="content">Moje raporty</div>
                                </Link>
                            </div>
                        </React.Fragment>
                    ) : null}
                    {this.props.type === "list" ? (
                        <ReportList key={history.location.search} />
                    ) : (this.props.type === "externalList" ? (
                        <ExternalList key={history.location.search} />
                    ) : (
                        <Report key={history.location.search} userID={this.props.match.params.userID} type={this.props.type} />
                    ))}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({ currentUser: state.user.current });

export default connect(mapStateToProps, {})(WorkingTime);